import { render } from "./App.vue?vue&type=template&id=f6cda360"
const script = {}

import exportComponent from "/Users/jerem/Desktop/My Code Project/Financial_Immo 2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__